



























import Vue from 'vue'
import Component from 'vue-class-component'
import { Getter, Action } from 'vuex-class'
import { Prop } from 'vue-property-decorator'

const namespace = 'digitalCurrency'

@Component({
  components: {}
})
class DigitalCurrency16AccountSettingsIntroduction extends Vue {

  @Prop({ default: '' }) accountId?: string

  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any
  @Getter('getDigitalCurrencyAccountSettings', { namespace }) getDigitalCurrencyAccountSettings?: any
  @Getter('getIsBlockedByDigitalCurrencyAccount', { namespace }) getIsBlockedByDigitalCurrencyAccount?: any

  @Action('updateDigitalCurrencyAccountSettings', { namespace }) updateDigitalCurrencyAccountSettings?: any

  async blockAccount () {
    const blockedAccountVariableTable = this.getDigitalCurrencyAccountSettings(this.getActiveDigitalCurrencyAccount.accountId).blockedAccountVariableTable || {}

    if (!this.accountId) {
      return
    }
    blockedAccountVariableTable[this.accountId] = true

    await this.updateDigitalCurrencyAccountSettings({
      propertyId: 'blockedAccountVariableTable',
      propertyValue: blockedAccountVariableTable
    })
  }

  async unblockAccount () {
    const blockedAccountVariableTable = this.getDigitalCurrencyAccountSettings(this.getActiveDigitalCurrencyAccount.accountId).blockedAccountVariableTable || {}

    if (!this.accountId) {
      return
    }
    delete blockedAccountVariableTable[this.accountId]

    await this.updateDigitalCurrencyAccountSettings({
      propertyId: 'blockedAccountVariableTable',
      propertyValue: blockedAccountVariableTable
    })
  }

  // Emit Toggle show content
  emitToggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.$emit('toggleShowContent', { isVisible })
  }
}

export default DigitalCurrency16AccountSettingsIntroduction


